import './style.scss';

function PrizeHeading(props) {
  return (
    <div className="PrizeHeading">
      <h1>{props.type}</h1>
    </div>
  );
}

function FirstPrize(props) {
  return (
    <div className="Prizes">
      {props.icon}
      <h2>{props.type}</h2>
      <a href={props.video}>
        <p>{props.content}</p>
      </a>
      <p>{props.integrantes}</p>
    </div>
  );
}

export {FirstPrize, PrizeHeading};
